<!--
  ~ Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->
<div class="btn-toolbar">
    <button class="btn btn-secondary btn-sm" (click)="getPending()">Refresh</button>
    <button class="btn btn-secondary btn-sm" [ifAuthorized]="'clikai:admin:clikdata:commit'" (click)="commitData()">
        Force Commit
    </button>
</div>

<table class="table">
    <thead>
        <tr>
            <th scope="col">Type ID</th>
            <th scope="col">Version</th>
            <th scope="col">Type Name</th>
            <th scope="col">Status</th>
            <th scope="col">Instance Key</th>
            <th scope="col">Subject ID</th>
            <th scope="col">Submitted Date</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of pendingList">
            <th scope="row">{{ item.id.split('-')[0].toUpperCase() }}</th>
            <td class="cell">{{ item.version }}</td>
            <td class="cell">{{ item.cliktype.split('.').pop().replace('$', ':') }}</td>
            <td class="cell">{{ item.status }}</td>
            <td class="cell">{{ item.clikkey }}</td>
            <td class="cell">{{ item.lastSubjectId }}</td>
            <td class="cell">{{ item.submitteddate | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
        </tr>
    </tbody>
</table>
